module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/slide_02-d230def840fe88143c4c3c17772f86c5.png";